import React from 'react';
import PlanDetails from './PlanDetails';

interface PlanDetailsDialogProps {
  visible: boolean;
  onHide: () => void;
  planId: number | null;
  clientId: string;
  setRefreshKey: (_value: number | ((_prev: number) => number)) => void;
  setLoading: (_loading: boolean) => void;
  isTemplate?: boolean;
}

/**
 * Thin wrapper around `PlanDetails`. Historically this component owned a
 * PrimeReact `<Dialog>`, but the v2 redesign of `PlanDetails` ships its own
 * Dialog shell — wrapping it here would render a dialog inside a dialog.
 */
export const PlanDetailsDialog: React.FC<PlanDetailsDialogProps> = ({
  visible,
  onHide,
  planId,
  clientId,
  setRefreshKey,
  setLoading,
  isTemplate = false
}) => {
  if (!planId) return null;
  return (
    <PlanDetails
      planId={planId}
      visible={visible}
      setPlanDetailsVisible={(value: boolean) => !value && onHide()}
      setRefreshKey={setRefreshKey}
      setLoading={setLoading}
      isTemplate={isTemplate}
      clientId={clientId}
    />
  );
};
